var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMobileLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logo_-_white",
    "data-name": "logo - white",
    transform: "translate(-179.344 -225.11)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9631",
    "data-name": "Group 9631",
    transform: "translate(179.344 225.11)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9629",
    "data-name": "Group 9629",
    transform: "translate(9.787 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_26384",
    "data-name": "Path 26384",
    d: "M218.04,225.1v10.422c.038,0,.074.006.113.006a10.315,10.315,0,0,0,10.314-10.314c0-.039-.005-.075-.006-.114Z",
    transform: "translate(-218.04 -225.1)",
    fill: "#f7be00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26385",
    "data-name": "Path 26385",
    d: "M228.467,302.439c-.038,0-.075-.006-.113-.006a10.315,10.315,0,0,0-10.314,10.314c0,.039.005.075.006.114h10.421Z",
    transform: "translate(-218.04 -282.861)",
    fill: "#965ec7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9630",
    "data-name": "Group 9630",
    transform: "translate(0 9.778)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_26386",
    "data-name": "Path 26386",
    d: "M179.344,274.165h10.422c0-.038.006-.075.006-.113a10.314,10.314,0,0,0-10.314-10.314c-.038,0-.075.005-.113.006Z",
    transform: "translate(-179.344 -263.738)",
    fill: "#3d7cc9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26387",
    "data-name": "Path 26387",
    d: "M256.741,263.738c0,.038-.006.075-.006.113a10.314,10.314,0,0,0,10.315,10.315c.037,0,.074-.005.112-.006V263.738Z",
    transform: "translate(-237.162 -263.738)",
    fill: "#ff8300"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileLogo);
export default __webpack_public_path__ + "static/media/mobileLogo.20cc288f3a9c3152974d5dd9f6fb9222.svg";
export { ForwardRef as ReactComponent };